<template>
<el-cascader
  v-model="query.siteDeviceIds"
  :options="JSON.parse(JSON.stringify(options))"
  :props="{
    multiple: true,
    emitPath: false
  }"
  collapse-tags
  size="small"
/>
</template>

<script>
export default {
  name: 'SiteDeviceQuery',
  props: {
    options: {
      required: true,
      type: Array
    },
    query: {
      required: true,
      type: Object
    }
  }
}
</script>

<style lang="scss" scoped>
.el-cascader {
  /deep/ {
    .el-input--small {
      .el-input__inner {
        height: 32px !important;
      }
    }
  }

  &.el-cascader--small {
    /deep/ {
      .el-cascader__tags {
        flex-wrap: nowrap;
        overflow: hidden;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Data/Query/SiteDeviceQuery.vue